

























































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { BoardActionsKeys, BoardActionsPayload } from '@/store/types/board';
import { RootGettersReturns } from '@/store/types';
import CreateLabel from './Labels/CreateLabel.vue';

@Component({
  components: {
    CreateLabel,
  },
})
export default class DashboardSidebar extends Vue {
  @Getter boardFilter!: RootGettersReturns['boardFilter'];
  @Getter labels!: RootGettersReturns['labels'];
  @Action(BoardActionsKeys['SET_FILTER']) setNewFilter!: (payload: BoardActionsPayload['SET_FILTER']) => void;

  showAll = false;

  get visibleLabels() {
    return this.showAll ? this.labels : this.labels.slice(0, 5);
  }

  toggleAllLabels() {
    this.showAll = !this.showAll;
  }

  setFilter(payload: BoardActionsPayload['SET_FILTER']) {
    this.setNewFilter(payload);
    if (this.$route.path !== '/dashboard' && this.$route.path !== '/dashboard/shared') {
      this.$router.push('/dashboard');
    }
  }
}
